import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import qs from 'qs'
import omitBy from 'lodash/omitBy'

Vue.use(Router)

export let router = new Router({
  // General
  mode: 'history',
  // routes,
  routes: [
    ...routes,
    { path: '/', name: 'dashboard', redirect: { name: 'bookings' } },
  ],

  // Functions
  parseQuery: query => {
    return qs.parse(query)
  },

  stringifyQuery: query => {
    let queryString = qs.stringify(omitBy(query, value => {
      return value === '' || value === null
    }), {
      arrayFormat: 'brackets'
    })
    return (queryString) ? `?${queryString}` : ''
  },

  // Preferences
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
})